import http from "../services/httpServices";
import React, { useContext, useEffect, useState, useRef } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from "react-toastify";
import utils from "../services/utilsServices";
import cardService from "../services/cardServices";
import { MainContext } from "../store/mainContext";
export default function Fabric({ show, handleClose }) {
    const { defaultDevice, setDefaultDevice } = useContext(MainContext);
    useEffect(() => {
    }, []);


    const [mode, setMode] = useState(-1)
    const formRef = useRef(null);

    const [isPosting, setIsPosting] = useState(false)
    const doPost = async (e) => {
        e.preventDefault();
        e.stopPropagation()
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error(utils.checkInput, { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        if (mode == -1) {
            toast.error('یکی از گزینه ها را انتخاب بفرمایید', { theme: "colored" });
            return;
        }
        utils.sendSms(defaultDevice.deviceNumber, `fabric,${mode}`);
        toast.success(utils.waitSms);
        handleClose(e)
    }

    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="bottom"
                className="customBottomCanvas "  >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="w-100 d-flex justify-content-center">  کنترل فابریک</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form ref={formRef} className=" needs-validation" >
                        <div className="row mb-3 border rounded p-2 border">
                            <div className="col">
                                <div className="form-check">
                                    <input
                                        checked={mode == 0}
                                        onChange={(e) => {
                                            setMode(0)
                                        }}
                                        className="form-check-input"
                                        type="radio"
                                        name="mode" />
                                    <label
                                        className="form-check-label"
                                        htmlFor="mode">
                                        غیرفعال
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3 border rounded p-2 border">
                            <div className="col">
                                <div className="form-check">
                                    <input
                                        checked={mode == 1}
                                        onChange={(e) => {
                                            setMode(1)
                                        }}
                                        className="form-check-input"
                                        type="radio"
                                        name="mode" />
                                    <label
                                        className="form-check-label"
                                        htmlFor="mode">
                                        فعال
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3 border rounded p-2 border">
                            <div className="col">
                                <div className="form-check">
                                    <input
                                        checked={mode == 2}
                                        onChange={(e) => {
                                            setMode(2)
                                        }}
                                        className="form-check-input"
                                        type="radio"
                                        name="mode" />
                                    <label
                                        className="form-check-label"
                                        htmlFor="mode">
                                        مولتی پلکس
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-3 '>
                            <div className='col'>
                                <button className='btn btn-warning w-100'
                                    disabled={isPosting}
                                    onClick={doPost}>تایید
                                    {isPosting &&
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    }
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );

}
